import { ColDef } from 'ag-grid-community';
import { UseSelectableRowGridLogicApi } from './useSelectableRowGridLogic';
import CheckboxCellRenderer from '../cellRenderers/checkboxCellRenderer.component';
import { alignCenterCellStyle } from '@common/cellStyles';
import { ICellRendererParamsWithData } from '../types';
import { addTooltipToCellRenderer } from '../cellRenderers/WithTooltipCellRenderer.component';


type SelectionCheckboxColumnFactoryParams<T extends Record<string, unknown>> = {
  selectionApi: UseSelectableRowGridLogicApi<T>,
  isDisabled?: (data: ICellRendererParamsWithData<T>) => boolean,
  getTooltipText?: (data: ICellRendererParamsWithData<T>) => string | null,
  cellRendererParams?: (params: ICellRendererParamsWithData<T>) => ColDef['cellRendererParams'],
}

export const selectionCheckboxColumnFactory = <T extends Record<string, unknown>, >({
  isDisabled,
  getTooltipText,
  selectionApi,
  cellRendererParams = () => ({}),
}: SelectionCheckboxColumnFactoryParams<T>): ColDef => ({
    cellRenderer: addTooltipToCellRenderer<T>(CheckboxCellRenderer(), getTooltipText),
    cellRendererParams: ({ data, node, api, ...rest }: ICellRendererParamsWithData<T> ) => ({
      isChecked: () => selectionApi.isSelected(data),
      isDisabled: () => !!isDisabled?.({ data, node, api, ...rest }),
      onSelect: () => {
        if (selectionApi.isSelected(data)) {
          selectionApi.unselectRow(data);
        } else {
          selectionApi.selectRow(data);
        }
        api.refreshCells({ rowNodes: [node], suppressFlash: true });
      },
      ...typeof cellRendererParams === 'function'
        ? cellRendererParams({ data, node, api, ...rest })
        : cellRendererParams,
    }),
    width: 40,
    minWidth: 40,
    ...alignCenterCellStyle,
  });
